import {
  QueueListIcon,
  ClockIcon,
  ClipboardDocumentIcon,
  CursorArrowRaysIcon,
  CheckBadgeIcon,
  NoSymbolIcon,
  ArrowPathRoundedSquareIcon,
} from "@heroicons/react/24/outline";
import { PERMISSIONS } from "../../PermissionsConstants";
import { InvoiceCapture } from "./InvoiceCapture";
import { InvoiceManager } from "./InvoiceManager";
import { ForReview } from "./ForReview";
import { SubmittedToAcumatica } from "./SubmittedToAcumatica";
import { Completed } from "./Completed";
import { Voided } from "./Voided";
import { ReconcilliationQueue } from "./Reconcilliation";

export const VendorInvoiceTabs = [
  {
    title: "Invoice Manager",
    component: InvoiceManager,
    to: "/vendortab/invoice/invoicemanager",
    path: "/vendortab/invoice/invoicemanager",
    permission: PERMISSIONS.permission_vendorinvoice_view,
    icon: <QueueListIcon className="w-5 h-5" />,
  },
  {
    title: "Pending/Unverified",
    component: InvoiceCapture,
    to: "/vendortab/invoice/pending",
    path: "/vendortab/invoice/pending",
    permission: PERMISSIONS.permission_vendorinvoice_view,
    icon: <ClockIcon className="w-5 h-5" />,
  },
  {
    title: "For Review",
    component: ForReview,
    to: "/vendortab/invoice/forreview",
    path: "/vendortab/invoice/forreview",
    permission: PERMISSIONS.permission_vendorinvoice_view,
    icon: <ClipboardDocumentIcon className="w-5 h-5" />,
  },
  {
    title: "Reconciliation",
    component: ReconcilliationQueue,
    to: "/vendortab/invoice/reconciliation",
    path: "/vendortab/invoice/reconciliation",
    permission: PERMISSIONS.permission_vendorinvoice_view,
    icon: <ArrowPathRoundedSquareIcon className="w-5 h-5" />,
  },
  {
    title: "Submitted",
    component: SubmittedToAcumatica,
    to: "/vendortab/invoice/acumatica",
    path: "/vendortab/invoice/acumatica",
    permission: PERMISSIONS.permission_vendorinvoice_view,
    icon: <CursorArrowRaysIcon className="w-5 h-5" />,
  },
  {
    title: "Completed",
    component: Completed,
    to: "/vendortab/invoice/completed",
    path: "/vendortab/invoice/completed",
    permission: PERMISSIONS.permission_vendorinvoice_view,
    icon: <CheckBadgeIcon className="w-5 h-5" />,
  },
  {
    title: "Voided",
    component: Voided,
    to: "/vendortab/invoice/voided",
    path: "/vendortab/invoice/voided",
    permission: PERMISSIONS.permission_vendorinvoice_view,
    icon: <NoSymbolIcon className="w-5 h-5" />,
  },
];
